/**
 * The team staff may act on from the Data refinery, or null: a TrainLoop
 * employee on their own team, never under impersonation (the api refuses
 * every write there) and never on a restricted demo team (the api refuses
 * that too, and its pages stay as they are). The staff actions
 * (RefineryActions) and what only staff can repair (the unreadable staff
 * requests) show to the same people. The api checks all of it again.
 */

import { useTeam } from '@/contexts/TeamContext'

export type StaffTeam = NonNullable<ReturnType<typeof useTeam>['activeTeam']>

export function useStaffTeam(): StaffTeam | null {
  const { meLoaded, isEmployee, isRestricted, impersonatingTeamId, activeTeam } = useTeam()
  if (!meLoaded || !isEmployee || isRestricted || impersonatingTeamId !== null) return null
  return activeTeam
}
